module.exports = __webpack_public_path__ + "static/img/全息成像.484353f0.png";